<script>
  import { getItemNameByType, isEdit, items } from "./stores.js";
  import { confirmDelete } from "../shared/utils.js";

  export let item;
  export let businessCode;
  export let itemType;
  let itemTypeName = getItemNameByType(itemType);

  const onDelete = async () => {
    items.deleteItem(itemType, businessCode, item.id);
  };

  const DEFAULT_IMAGE_PATH = "/static/images/tab-worldmap-small.jpg";
</script>

<style>
  .card-img {
    /* zoom to fit card size */
    object-fit: cover;
  }
  /* responsive styling to make modal full width on mobile */
  @media only screen and (max-width: 768px) {
    :global(.window) {
      width: 100% !important;
    }
    :global(.window-wrap) {
      margin: 0.5rem !important;
    }
  }
</style>

<div
  class="card rounded-lg text-white border-0 shadow overflow-hidden {!$isEdit
    ? 'hover-scale'
    : ''}"
  style={!$isEdit ? "cursor: pointer;" : ""}
  role="button"
  on:click>
  <!-- Cards height is based on h/w ratio -->
  <div class="dark-overlay embed-responsive embed-responsive-4by3">
    {#if item.image_link_uuid}
      <img
        class="card-img embed-responsive-item"
        data-blink-uuid={item.image_link_uuid}
        data-blink-quality="lightest"
        data-blink-scale-crop="450x300"
        data-blink-scale-crop-position="smart"
        alt={item.title} />
    {:else}
      <img
        class="card-img embed-responsive-item"
        data-blink-src={DEFAULT_IMAGE_PATH}
        alt={item.title} />
    {/if}
    <div class="card-img-overlay d-flex align-items-start z-index-20 p-2 p-md-4">
      <!-- Align to the top of the card -->
      <span class="h5 card-title font-weight-normal text-truncate-4">
        {item.title}
      </span>
    </div>
  </div>
  {#if $isEdit}
    <!-- Show edit footer -->
    <div class="card-footer d-flex justify-content-end pr-2">
      <div class="btn btn-outline-dark btn-sm px-3 mr-1 text-right" on:click>Edit</div>
      <div
        class="btn btn-outline-danger btn-sm px-3 text-right"
        on:click|stopPropagation={() => confirmDelete(itemTypeName, onDelete)}>
        Delete
      </div>
    </div>
  {/if}
</div>
